import { Feature, FeatureFlag, featureFlagConfigDecoder, FeatureFlagConfigEditorKind, featureFlagConfigEditorKind, featureFlagHasOptionalConfigWhenEnabled, nullDecoder, } from "./features.dtos";
import { enumValues } from "./utils";
export var FeatureScope;
(function (FeatureScope) {
    FeatureScope["GLOBAL"] = "global";
    FeatureScope["ORGANIZATION"] = "organization";
    FeatureScope["PATIENT"] = "patient";
    FeatureScope["NONE"] = "none";
})(FeatureScope || (FeatureScope = {}));
export const FEATURE_SCOPE_LEVELS = [FeatureScope.GLOBAL, FeatureScope.ORGANIZATION, FeatureScope.PATIENT];
export function applicableFeatureScopeLevels(scopeContext) {
    const levels = [FeatureScope.GLOBAL];
    if (scopeContext.organizationId) {
        levels.push(FeatureScope.ORGANIZATION);
    }
    if (scopeContext.patientId) {
        levels.push(FeatureScope.PATIENT);
    }
    return levels;
}
export function resolveFeatureScopeRecord(levels, scopeContext) {
    const applicableLevels = applicableFeatureScopeLevels(scopeContext);
    for (let index = applicableLevels.length - 1; index >= 0; index--) {
        const level = applicableLevels[index];
        const record = levels[level];
        if (record !== undefined) {
            return { scope: level, record };
        }
    }
    return null;
}
export function resolveFeatureEnablement(levels, scopeContext) {
    const resolved = resolveFeatureScopeRecord(levels, scopeContext);
    if (!resolved) {
        return { resolvedScope: FeatureScope.NONE, resolvedEnabled: false };
    }
    return {
        resolvedScope: resolved.scope,
        resolvedEnabled: resolved.record.enabled,
        lastUpdatedAt: resolved.record.updatedAt,
    };
}
export function requiresFeatureConfiguration(feature) {
    const decoder = featureFlagConfigDecoder(feature);
    return decoder !== nullDecoder && !featureFlagHasOptionalConfigWhenEnabled(feature);
}
export function blankConfigurationMeansEmptyObject(feature) {
    switch (featureFlagConfigEditorKind(feature)) {
        case FeatureFlagConfigEditorKind.BackgroundDataRefresh:
        case FeatureFlagConfigEditorKind.PatientNudgeNotifications:
        case FeatureFlagConfigEditorKind.AiRecordsReadyEmailDelay:
        case FeatureFlagConfigEditorKind.RetrievalStats:
            return true;
        case FeatureFlagConfigEditorKind.Json:
        case FeatureFlagConfigEditorKind.Date:
        case FeatureFlagConfigEditorKind.Enum:
        case FeatureFlagConfigEditorKind.EnumArray:
        case FeatureFlagConfigEditorKind.UrlArray:
            return false;
    }
}
export function validateFeatureConfiguration(feature, enabled, configuration) {
    if (!enabled) {
        return { valid: true };
    }
    if (requiresFeatureConfiguration(feature) && configuration === null) {
        return {
            valid: false,
            error: `Configuration is required for feature flag ${feature} when enabling`,
        };
    }
    if (configuration !== null) {
        const tempFeature = new Feature({
            feature,
            enabled,
            configuration,
        });
        try {
            const decoded = tempFeature.decodeConfiguration();
            if (decoded === null) {
                return {
                    valid: false,
                    error: `Configuration could not be decoded for feature flag ${feature}`,
                };
            }
        }
        catch (error) {
            return {
                valid: false,
                error: `Invalid configuration for feature flag ${feature}: ${String(error)}`,
            };
        }
    }
    return { valid: true };
}
const adminFeatureFlags = enumValues(FeatureFlag).filter((feature) => !feature.startsWith("TEST"));
export function adminFeatureFlagsForUi() {
    return adminFeatureFlags;
}
